import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from '@app/app.routes';
import { authConfig } from '@app/core/auth/auth.config';
import { authInterceptor } from '@app/core/interceptors/auth.interceptor';
import { globalErrorInterceptor } from '@app/core/interceptors/global-error.interceptor';
import { OAuthService, OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';

export async function initializeAuth(): Promise<void> {
  const oauthService = inject(OAuthService);
  oauthService.configure(authConfig);
  await oauthService.loadDiscoveryDocumentAndTryLogin();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideHttpClient(withInterceptors([authInterceptor, globalErrorInterceptor])),
    provideRouter(routes, withComponentInputBinding()),

    provideOAuthClient(),

    { provide: OAuthStorage, useValue: sessionStorage },

    provideAppInitializer(initializeAuth),

    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: {
        hasBackdrop: true,
        autoFocus: 'first-tabbable',
        restoreFocus: true,
      },
    },
  ],
};
